import React from "react";
import { motion } from "framer-motion";

const FarmStatusBanner = ({ farm, isArabic }) => {
  const statusItems = [
    {
      icon: "🌾",
      label: isArabic ? "الحقول" : "Fields",
      value: farm.fields?.length || farm.fieldsCount || "—",
    },
    {
      icon: "📐",
      label: isArabic ? "المساحة" : "Total Area",
      value: farm.size || "—",
    },
    {
      icon: "💧",
      label: isArabic ? "مصدر المياه" : "Water Source",
      value: farm.waterSource || (isArabic ? "آبار عميقة" : "Deep Wells"),
    },
    {
      icon: "☀️",
      label: isArabic ? "الطاقة" : "Energy",
      value: farm.solar || "—",
    },
  ];

  return (
    <div className="rounded-2xl overflow-hidden border border-emerald-200 bg-white shadow-lg">
      {/* Green hero bar */}
      <div className="bg-gradient-to-r from-emerald-700 via-emerald-600 to-teal-600 text-white px-6 py-5 md:py-6">
        <div className={`flex items-start justify-between flex-wrap gap-4 ${isArabic ? "flex-row-reverse" : ""}`}>
          <div>
            <div className={`flex items-center gap-2 mb-1 ${isArabic ? "flex-row-reverse" : ""}`}>
              <span className="relative flex h-2.5 w-2.5">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-300 opacity-75" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-emerald-200" />
              </span>
              <span className="text-[10px] font-mono uppercase tracking-[0.2em] text-emerald-200">
                {isArabic ? "حالة المزرعة الحالية" : "Current Farm Status"}
              </span>
            </div>
            <h3 className="text-xl md:text-2xl font-bold tracking-tight mb-1">{farm.name}</h3>
            <p className="text-sm text-emerald-100 mb-0">{farm.region}</p>
          </div>
          <div className="flex items-center gap-2">
            <span className="px-3 py-1 bg-white/15 backdrop-blur-sm rounded-full text-xs font-bold text-emerald-50 border border-white/20">
              {farm.crops}
            </span>
          </div>
        </div>
      </div>

      {/* Stats strip */}
      <div className={`grid grid-cols-2 md:grid-cols-4 divide-x ${isArabic ? "divide-x-reverse" : ""} divide-emerald-100`}>
        {statusItems.map((item, i) => (
          <motion.div
            key={item.label}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.1, duration: 0.4 }}
            className={`px-4 py-4 ${isArabic ? "text-right" : ""}`}
          >
            <div className={`flex items-center gap-2 mb-1 ${isArabic ? "flex-row-reverse" : ""}`}>
              <span className="text-base">{item.icon}</span>
              <span className="text-[10px] font-bold uppercase tracking-widest text-slate-400">{item.label}</span>
            </div>
            <p className="text-sm font-bold text-slate-900 mb-0">{item.value}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default FarmStatusBanner;
